module.exports = __webpack_public_path__ + "92a926394223788845d7863a24cbe27b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sap_america_2022_chart.png
// module id = 1732
// module chunks = 0